export default {
  getPaymentMethods: (state) => state.paymentMethods,
  getPaymentMethodsToPOS: (state) => [
    {
      name: "Efectivo",
      type: "CASH",
    },
    ...(state.paymentMethods || [])
      .filter((pm) => !["DEB_CRED", "TRANSFER", "UPON_DELIVERY"].includes(pm.type))
      .map((pm) => ({ id: pm.id, name: pm.name, type: pm.type })),
    {
      name: "POS",
      type: "POS",
    },
    {
      name: "Delivery",
      type: "DELIVERY",
    },
  ],
  getPaymentMethodsDeliveryTypes: (state) => state.paymentMethodsDeliveryTypes,
  getActiveOnPOSPaymentMethods: (state) => [
    {
      id: "BYsvNveYmQIcxu8jMjG4",
      deleted: false,
      team_id: "fivemoons",
      name: "Efectivo",
      schema: [],
      created_at: {
        _seconds: 1664294027,
        _nanoseconds: 120000000,
      },
      description: "Realice su compra con pago con efectivo",
      active: true,
      type: "CASH",
    },
    ...(state.paymentMethods || [])?.filter((pm) => pm.active_on_pos),
    {
      id: "delivery",
      name: "Delivery",
      schema: [],
      active: true,
      type: "DELIVERY",
    },
  ],
  getPaymentPassarella: (state) => state.paymentMethods?.find((pm) => pm.type === "DEB_CRED"),
  getPaymentTransfer: (state) => state.paymentMethods?.find((pm) => pm.type === "TRANSFER"),
  getPaymentYape: (state) => state.paymentMethods?.find((pm) => pm.type === "YAPE"),
  getPaymentUponDelivery: (state) => state.paymentMethods?.find((pm) => pm.type === "UPON_DELIVERY"),
};
